export const BLOG_TAGS = [
  'prompts',
  'ai-workflows',
  'case-study',
  'tutorial',
  'best-practices',
  'news',
  'api',
  'integration',
  'performance',
  'security',
] as const

export type BlogTag = (typeof BLOG_TAGS)[number]

export const BLOG_CONSTANTS = {
  POSTS_PER_PAGE: 8,
  POSTS_PER_SHOW_MORE: 8,
  WORDS_PER_MINUTE_PROSE: 238,
  WORDS_PER_MINUTE_CODE: 100,
  MIN_SLUG_LENGTH: 3,
  MAX_SLUG_LENGTH: 100,
  SLUG_REGEX: /^[a-z0-9-]{3,100}$/,
  HEADING_DEBOUNCE_MS: 100,
  SCROLL_DEPTH_THRESHOLDS: [25, 50, 75, 100] as const,
  ANALYTICS_RATE_LIMIT_WINDOW_MS: 10000,
  ANALYTICS_RATE_LIMIT_MAX_EVENTS: 10,
  SHARE_FEEDBACK_DURATION_MS: 2000,
}

export const BLOG_SEO = {
  title: 'Blog | PromptVan',
  description:
    'Insights, tutorials, and best practices for AI-powered workflows with PromptVan: prompt engineering, agents, pipelines and the practitioners building them.',
  keywords: ['prompts', 'ai', 'workflows', 'tutorials', 'best practices'],
}
